var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChartTab(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2497 12.4074H1.74972C1.686 12.4073 1.62471 12.3829 1.57838 12.3392C1.53205 12.2954 1.50416 12.2356 1.50043 12.172C1.4967 12.1084 1.51739 12.0458 1.55829 11.9969C1.59919 11.9481 1.6572 11.9167 1.72047 11.9091C5.83647 11.4249 7.02147 9.05488 8.27472 6.54563C9.53497 4.02788 10.8365 1.42488 15.2205 0.909127C15.2555 0.904742 15.2911 0.907966 15.3248 0.918579C15.3585 0.929192 15.3895 0.946945 15.4157 0.970627C15.4421 0.994062 15.4632 1.02282 15.4777 1.05501C15.4922 1.08719 15.4997 1.12208 15.4997 1.15738V12.1574C15.4997 12.2237 15.4734 12.2873 15.4265 12.3342C15.3796 12.381 15.316 12.4074 15.2497 12.4074Z",
    fill: "#CED4DA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.25 13.4072H0.75C0.683696 13.4072 0.620107 13.3809 0.573223 13.334C0.526339 13.2871 0.5 13.2235 0.5 13.1572V1.15723C0.5 1.09092 0.526339 1.02733 0.573223 0.98045C0.620107 0.933566 0.683696 0.907227 0.75 0.907227C0.816304 0.907227 0.879893 0.933566 0.926777 0.98045C0.973661 1.02733 1 1.09092 1 1.15723V12.9072H15.25C15.3163 12.9072 15.3799 12.9336 15.4268 12.9804C15.4737 13.0273 15.5 13.0909 15.5 13.1572C15.5 13.2235 15.4737 13.2871 15.4268 13.334C15.3799 13.3809 15.3163 13.4072 15.25 13.4072Z",
    fill: "#CED4DA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartTab);
export default __webpack_public_path__ + "static/media/chartTab.a088f97843a6c6a11553393fc37bc9f5.svg";
export { ForwardRef as ReactComponent };